import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom';

import i18n from 'i18next';
import { connect } from 'react-redux';

import history from './history';
import { ActivePageService } from './services/active-page';
import Menu from './containers/Menu';
import UserPage from './containers/User';
import MonthlyOverview from './containers/MonthlyOverview';
import Auth from './containers/Auth';
import Header from './containers/Header';

import HomePage from './components/home-page';
import AdminPanel from './components/admin-panel';
import FilesUpload from './components/files-upload';
import MissedFiles from './components/missed';
import EmailTrackingReport from './components/email-tracking';
import AuthHistoryReport from './components/auth-history';
import Accounts from './components/accounts';
// import MonthlyReport from './components/monthly-report';
import Salaries from './components/salaries';
import SalaryActions from './components/salary-actions';
import GeneralDocuments from './components/general-documents';
import InvoiceRequest from './components/requests/invoice-request';
import ExpenseRequest from './components/requests/expense-request';
import SupportTicket from './components/requests/support-ticket';
import MyRequests from './components/requests/my-requests';

import './App.scss';
import { Routes } from "./api/routes";
import ProjectManagement from './components/project-management';

export function mapStateToProps({ userState }) {
  return {
    user: userState.user,
  };
}

const AppRoutes = (props) => {
  const { user } = props;
  const location = useLocation();
  const isSalariesFullScreen = location.pathname === Routes.salariesFullScreen;
  const [currentLng, setCurrentLng] = useState(i18n.language);
  const [menuClassName, setMenuClassName] = useState('nav-bar');
  const [refreshingContent, setRefreshingContent] = useState(false);
  const [activePage, setActivePage] = useState(
    ActivePageService.getActivePageUrl(history.location.pathname)
  );

  useEffect(() => {
    if (refreshingContent)
      setRefreshingContent(false);
  }, [refreshingContent]);

  const handleNavBar = () => {
    if (menuClassName === 'nav-bar') {
      setMenuClassName('nav-bar close');
      setTimeout(() => setMenuClassName('nav-bar disappear'), 1000);
      return;
    }
    setMenuClassName('nav-bar close');
    setTimeout(() => setMenuClassName('nav-bar'), 0);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setCurrentLng(lng);
  };


  useEffect(() => {
    const direction = i18n.language === 'heb' ? 'rtl' : 'ltr';
    document.body.dir = direction;
  }, [i18n.language]);

  if (isSalariesFullScreen) {
    return (
      <main className="salaries-full-screen-main">
        <Salaries user={user} fullScreen />
      </main>
    );
  }

  return (
      <main>
        {user.id && (
          <Menu
            user={user}
            menuClassName={menuClassName}
            setMenuClassName={setMenuClassName}
            handleDrawer={handleNavBar}
            currentLng={currentLng}
            changeLanguage={changeLanguage}
            activePage={activePage}
            refreshContent={() => setRefreshingContent(true)}
          />
        )}
        {!refreshingContent &&
          <div className="content">
            <Header
              user={user}
              currentLng={currentLng}
              changeLanguage={changeLanguage}
              handleDrawer={handleNavBar}
              setActivePage={setActivePage}
            />
            <Switch>
              <Route
                exact
                path={Routes.main}
                render={() => {
                  return user.id ? (
                    <HomePage user={user} handleDrawer={handleNavBar} />
                  ) : <Redirect to={Routes.signIn} />
                }}
              />
              <Route
                exact
                path={Routes.signIn}
                render={() => !user.id ? <Auth currentLng={currentLng} changeLanguage={changeLanguage} /> :
                  <Redirect to={Routes.main} />}
              />
              <Route
                path={Routes.oneTimePassword}
                render={() => {
                  return !user.id ? <Auth currentLng={currentLng} changeLanguage={changeLanguage} /> :
                    <Redirect to={Routes.main} />;
                }}
              />
              <Route
                exact
                path="/monthly-overview"
                render={() => {
                  return user.id ? <MonthlyOverview user={user} /> : null;
                }}
              />
              <Route
                exact
                path="/monthly-overview/:type"
                render={() =>
                  user.id ? <MonthlyOverview user={user} /> : null
                }
              />


              <Route
                exact
                path="/admin-panel"
                render={() => {
                  return user.id && user.role === 'admin' ? (
                    <AdminPanel user={user} />
                  ) : null;
                }}
              />

              <Route
                exact
                path="/admin-panel/:type"
                render={() =>
                  user.id && user.role === 'admin' ? (
                    <AdminPanel />
                  ) : null
                }
              />
              <Route
                exact
                path={Routes.accounts}
                render={() => {
                  return user.id && user.role === 'admin' ? (
                    <Accounts user={user} />
                  ) : null;
                }}
              />
              {/*<Route*/}
              {/*  exact*/}
              {/*  path={Routes.monthlyReport}*/}
              {/*  render={() => <MonthlyReport user={user}/>}*/}
              {/*/>*/}
              <Route
                exact
                path={Routes.salaries}
                render={() => <Salaries user={user} />}
              />
              <Route
                exact
                path={Routes.salaryActions}
                render={() => {
                  return user.id && user.role === 'admin' ? (
                    <SalaryActions />
                  ) : null;
                }}
              />
              <Route
                exact
                path="/project-management"
                render={() => <ProjectManagement />}
              />
              <Route
                exact
                path={Routes.generalDocuments}
                render={() => {
                  return user.id ? <GeneralDocuments userId={user.id} /> : null;
                }}
              />
              <Route
                exact
                path={Routes.invoiceRequest}
                render={() => {
                  return user.id ? <InvoiceRequest /> : null;
                }}
              />
              <Route
                exact
                path={Routes.expenseRequest}
                render={() => {
                  return user.id ? <ExpenseRequest /> : null;
                }}
              />
              <Route
                exact
                path={Routes.serviceCall}
                render={() => {
                  return user.id ? <SupportTicket /> : null;
                }}
              />
              <Route
                exact
                path={Routes.myRequests}
                render={() => {
                  return user.id ? <MyRequests user={user} /> : null;
                }}
              />
              <Route
                exact
                path="/files-upload"
                render={() => {
                  return user.id && user.role === 'admin' ? (
                    <FilesUpload />
                  ) : null;
                }}
              />
              <Route
                exact
                path="/missed"
                render={() => {
                  return user.id && user.role === 'admin' ? (
                    <MissedFiles />
                  ) : null;
                }}
              />
              <Route
                exact
                path={Routes.emailTrackingReport}
                render={() => {
                  return user.id && user.role === 'admin' ? (
                    <EmailTrackingReport />
                  ) : null;
                }}
              />
              <Route
                exact
                path={Routes.authHistory}
                render={() => {
                  return user.id && user.role === 'admin' ? (
                    <AuthHistoryReport />
                  ) : null;
                }}
              />
              <Route
                exact
                path="/user/:id"
                render={() => {
                  return user.id ? <UserPage /> : null;
                }}
              />
              <Route render={() => <Redirect to="/" />} />
            </Switch>
          </div>}
      </main>
  );
};

const App = (props) => (
  <Router history={history}>
    <AppRoutes user={props.user} />
  </Router>
);

export default connect(mapStateToProps)(App);
